import { Box, Typography } from "@mui/material";

import NavGroup from "./NavGroup";
import menuItem from "../../../../../menu-items";
import NavAccordion from "./NavAccordion";

const Navigation = () => {
  const navGroups = menuItem.items.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      case "accordion":
        return <NavAccordion key={item.id} item={item} level={1} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
